// extracted by mini-css-extract-plugin
module.exports = {"AlignRight":"ViewDetailsButton_AlignRight__ICfWy"};